var Commun = require('./Commun/Commun.fr.json')
var Home = require('./Home/Home.fr.json')
var Actualites = require('./Actualites/Actualites.fr.json')

Commun.NotDefinied = ''

export default {
  Commun,
  Home,
  Actualites
}
